import { render, staticRenderFns } from "./FodderTableMobile.vue?vue&type=template&id=14a69901&scoped=true&"
import script from "./FodderTableMobile.vue?vue&type=script&lang=js&"
export * from "./FodderTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./FodderTableMobile.vue?vue&type=style&index=0&id=14a69901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a69901",
  null
  
)

export default component.exports